module.exports = __webpack_public_path__ + "img/q5.8dafdc9c.png";